import axios from '@/lib/axios'
import {
  buildAdminRequestConfig,
  type OrganizationId,
  type ScopedAdminQueryKey,
} from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type { FeeSettings, FeeSettingsInput } from './fee-settings.types'

export async function getFeeSettings({
  queryKey: [{ organizationId }],
}: QueryFunctionContext<ScopedAdminQueryKey>) {
  return axios.get<FeeSettings>('/fee-settings', buildAdminRequestConfig({ organizationId }))
}

export async function updateFeeSettings({
  organizationId,
  values,
}: {
  organizationId: OrganizationId
  values: FeeSettingsInput
}) {
  return axios.put<FeeSettings>(
    '/fee-settings',
    values,
    buildAdminRequestConfig({ organizationId })
  )
}
